import React from 'react';
import { SectionHead, Icon, Action } from './Primitives';
import './UnityAiCredits.css';
import { catalog, money, number, gross } from '../config/pricing';
export default function UnityAiCredits({ onTopUp, vatRate = 0.15 }) {
  const pack = catalog.ai.topups[0],
    deliver = catalog.plans.find((p) => p.id === 'deliver');
  return (
    <section className="ul-section ul-ai" id="ai-credits">
      <div className="ul-container ul-ai-grid">
        <div>
          <SectionHead
            eyebrow="Plan your AI allowance"
            title={
              <>
                Keep creating.
                <br />
                Keep control of the cost.
              </>
            }
          >
            The proposed plans include monthly Unity AI allowances. Explore how credits could
            support your team, and manage your existing balance in your Unity account.
          </SectionHead>
          <div className="ul-ai-benefits">
            <p>
              <Icon name="check" />
              Review available estimates before generation.
            </p>
            <p>
              <Icon name="check" />
              Review a live account quote before adding funds.
            </p>
            <p>
              <Icon name="check" />
              Keep using saved content when generation credit runs out.
            </p>
          </div>
          <Action onClick={onTopUp} secondary>
            Explore AI funding options
          </Action>
          <p className="ul-note">
            These illustrative packs use a proposed rate of 100 credits per R1 of AI service
            value, not raw model tokens. Your live account quote confirms the actual charge,
            wallet funding and applicable terms.
          </p>
        </div>
        <div className="ul-wallet-preview">
          <div className="ul-wallet-top">
            <Icon name="spark" size={24} />
            <span>ILLUSTRATIVE WORKSPACE AI CREDITS</span>
          </div>
          <div className="ul-wallet-balance">
            <b>{number(deliver.monthlyAiCredits)}</b>
            <span>proposed monthly Deliver allowance</span>
          </div>
          <div className="ul-wallet-meter">
            <i />
          </div>
          <div className="ul-wallet-detail">
            <span>Shared across your team</span>
            <span>Used as you create</span>
          </div>
          <div className="ul-wallet-pack">
            <div>
              <span>ILLUSTRATIVE PROPOSED PACK</span>
              <strong>+{number(pack.credits)} credits</strong>
              <small>
                {money(pack.priceZar * 100)} ex VAT
                {vatRate > 0 && <> · {money(gross(pack.priceZar * 100, vatRate))} incl VAT</>}
              </small>
            </div>
            <button type="button" aria-label="Explore AI funding options for your account" onClick={onTopUp}>
              <Icon name="plus" />
            </button>
          </div>
          <p>
            Proposed pack: {money(pack.priceZar * 100)} ex VAT. Live account quotes confirm
            available funding options.
          </p>
          <span className="ul-wallet-disclosure">
            Illustrative wallet · no live account balance
          </span>
        </div>
      </div>
    </section>
  );
}
